import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../hanbirovn.css";
import "../../Style/typo.css";
import LazyMap from "../../container/component/map/lazymap";
import langData from "../../translations/translations.json";

function MapAddress({ lang = "ko" }) {
    const content = langData.mapad;

    return (
        <div className="wrap-block head-office" id="contact">
            <div className="fit-block">
                <div className="wrap-block-tt">
                    <p className="typo-32">{content["headOfficeTitle"][lang]}</p>
                </div>

                <div className="wrap-block-ct">
                    <ul className="nav nav-pills office-nav purple-bg" id="pills-tab" role="tablist">
                        <li className="navtab-item" role="presentation">
                            <button
                                className="nav-link office-tab typo-21 typo-medium active"
                                id="pills-address1-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-address1"
                                type="button"
                                role="tab"
                                aria-controls="pills-address1"
                                aria-selected="true"
                            >
                                {content["korea"][lang]}
                            </button>
                        </li>
                        <li className="navtab-item" role="presentation">
                            <button
                                className="nav-link office-tab typo-21 typo-medium"
                                id="pills-address2-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-address2"
                                type="button"
                                role="tab"
                                aria-controls="pills-address2"
                                aria-selected="false"
                            >
                                {content["vietnam"][lang]}
                            </button>
                        </li>
                        <li className="navtab-item" role="presentation">
                            <button
                                className="nav-link office-tab typo-21 typo-medium"
                                id="pills-address3-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-address3"
                                type="button"
                                role="tab"
                                aria-controls="pills-address3"
                                aria-selected="false"
                            >
                                {content["usa"][lang]}
                            </button>
                        </li>
                        <li className="navtab-item" role="presentation">
                            <button
                                className="nav-link office-tab typo-21 typo-medium"
                                id="pills-address4-tab"
                                data-bs-toggle="pill"
                                data-bs-target="#pills-address4"
                                type="button"
                                role="tab"
                                aria-controls="pills-address4"
                                aria-selected="false"
                            >
                                {content["china"][lang]}
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane show active" id="pills-address1" role="tabpanel" aria-labelledby="pills-address1-tab">
                            <div className="wrap-content-box-address">
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["ko-location1"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["office"][lang]}</p>
                                        <p className="typo-14">{content["ko-office-ad"][lang]}</p>
                                    </div>
                                </div>
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["ko-location2"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["ko-idc1"][lang]}</p>
                                        <p className="typo-14">{content["ko-ad1"][lang]}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="wrap-content-box-address">
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["ko-location3"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["ko-idc2"][lang]}</p>
                                        <p className="typo-14">{content["ko-ad2"][lang]}</p>
                                    </div>
                                </div>
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["ko-location4"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["ko-idc3"][lang]}</p>
                                        <p className="typo-14">{content["ko-ad3"][lang]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="pills-address2" role="tabpanel" aria-labelledby="pills-address2-tab">
                            <div className="wrap-content-box-address">
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["vn-location1"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["office"][lang]}</p>
                                        <p className="typo-14 address-2">{content["vn-office-ad"][lang]}</p>
                                        <p className="typo-14">{content["vn-office-ct"][lang]}</p>
                                    </div>
                                </div>
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["vn-location2"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["vn-idc"][lang]}</p>
                                        <p className="typo-14 address-2">{content["vn-ad"][lang]}</p>
                                        <p className="typo-14">{content["vn-idc-ct"][lang]}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane" id="pills-address3" role="tabpanel" aria-labelledby="pills-address3-tab">
                            <div className="wrap-content-box-address">
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["usa-location"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["office"][lang]}</p>
                                        <p className="typo-14">{content["usa-office-ad"][lang]}</p>
                                    </div>
                                </div>
                                <div className="item-address"></div>
                            </div>
                        </div>
                        <div className="tab-pane" id="pills-address4" role="tabpanel" aria-labelledby="pills-address4-tab">
                            <div className="wrap-content-box-address">
                                <div className="item-address">
                                    <div className="map-wp">
                                        <LazyMap src={content["china-location"][lang]} />
                                    </div>
                                    <div className="map-text-box">
                                        <p className="typo-21-sm typo-medium">{content["office"][lang]}</p>
                                        <p className="typo-14">{content["china-office-ad"][lang]}</p>
                                    </div>
                                </div>
                                <div className="item-address"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MapAddress;
